module.exports = "/wwwroot/img/waste_page.png?ver=e3a1fd34";